(() => {
  'use strict';

  function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const form = root.querySelector('[data-hgs-form]');
    const button = root.querySelector('[data-hgs-submit]');
    const review = root.querySelector('[data-hgs-review]');
    const error = root.querySelector('[data-hgs-error]');
    const status = root.querySelector('[data-hgs-status]');
    const copy = JSON.parse(root.querySelector('[data-hgs-copy]').textContent);
    const preview = root.dataset.preview !== 'false';
    const fields = ['business', 'brewing', 'website'];
    const storageKey = 'hg-sample-kit-preview-v1';
    const pendingKey = 'hg-sample-kit-pending-v1';
    const lifetime = 3600000;
    let busy = false;
    let completed = false;
    let uncertain = false;
    const selected = () => form.querySelector('[name="kit"]:checked');
    const controls = () => form.querySelectorAll('input, select, button');

    function read(key) {
      try { return JSON.parse(sessionStorage.getItem(key) || 'null'); }
      catch (_) { remove(key); return null; }
    }
    function remove(key) {
      try { sessionStorage.removeItem(key); } catch (_) {}
    }
    function save() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({
          kit: selected().value,
          values: Object.fromEntries(fields.map(key => [key, form.elements[key].value])),
          saved: Date.now()
        }));
      } catch (_) {}
    }
    function validPending(value) {
      return value && typeof value === 'object' &&
        typeof value.token === 'string' && /^[a-zA-Z0-9-]{16,100}$/.test(value.token) &&
        typeof value.variant === 'string' && /^\d+$/.test(value.variant) &&
        Number.isFinite(value.saved) && value.saved <= Date.now();
    }
    function pending() {
      const value = read(pendingKey);
      if (validPending(value)) return value;
      if (value !== null) remove(pendingKey);
      return null;
    }
    function markPending(value) {
      try {
        sessionStorage.setItem(pendingKey, JSON.stringify(value));
        return validPending(read(pendingKey));
      } catch (_) { return false; }
    }
    function lockControls() {
      controls().forEach(control => { control.disabled = busy || completed || uncertain; });
      if (!busy && !completed && !uncertain) {
        button.disabled = selected().dataset.available !== 'true';
      }
    }
    function update() {
      const option = selected();
      root.querySelector('[data-hgs-seasonal]').hidden = option.value !== 'trio';
      root.querySelector('[data-hgs-coffees]').classList.toggle('is-trio', option.value === 'trio');
      root.querySelector('[data-hgs-selection]').textContent = option.dataset.title;
      root.querySelector('[data-hgs-price]').textContent = option.dataset.price;
      button.firstChild.textContent = option.dataset.available === 'true' ?
        (preview ? copy.review : copy.add) : copy.soldOut;
      review.hidden = true;
      lockControls();
      save();
    }
    const saved = read(storageKey);
    if (saved && Number.isFinite(saved.saved) && saved.saved <= Date.now() &&
        Date.now() - saved.saved < lifetime && ['pair', 'trio'].includes(saved.kit) &&
        saved.values && typeof saved.values === 'object') {
      const choice = form.querySelector('[name="kit"][value="' + saved.kit + '"]');
      if (choice) choice.checked = true;
      fields.forEach(key => {
        if (typeof saved.values[key] === 'string') {
          form.elements[key].value = saved.values[key].slice(0, key === 'website' ? 250 : 120);
        }
      });
    } else if (saved !== null) {
      remove(storageKey);
    }
    function validate() {
      let first = null;
      fields.forEach(key => {
        const field = form.elements[key];
        field.value = field.value.trim();
        let valid = key === 'website' || field.value.length > 0;
        if (key === 'website' && field.value) {
          try {
            const url = new URL(field.value);
            valid = ['https:', 'http:'].includes(url.protocol) && url.hostname.includes('.');
          } catch (_) { valid = false; }
        }
        field.setAttribute('aria-invalid', String(!valid));
        root.querySelector('[data-error="' + key + '"]').hidden = valid;
        if (!valid) { const details = field.closest?.('details'); if (details) details.open = true; }
        if (!valid && !first) first = field;
      });
      save();
      if (first) first.focus();
      return !first;
    }
    function showError(message, cartLink = false) {
      error.textContent = message;
      if (cartLink) {
        const link = document.createElement('a');
        link.href = root.dataset.cartUrl;
        link.textContent = ' ' + copy.added;
        error.append(link);
      }
      error.hidden = false;
      status.textContent = '';
    }
    async function reconcile(marker) {
      const controller = typeof AbortController === 'undefined' ? null : new AbortController();
      const timeout = controller ? setTimeout(() => controller.abort(), 12000) : null;
      try {
        const response = await fetch(root.dataset.cartUrl + '.js', {
          headers: {'Accept': 'application/json'},
          cache: 'no-store',
          ...(controller ? {signal: controller.signal} : {})
        });
        if (!response.ok) throw new Error('cart unavailable');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('invalid cart');
        return cart.items.some(item =>
          String(item.variant_id || item.id) === marker.variant &&
          item.properties && item.properties._hg_sample_request === marker.token
        );
      } catch (_) { return null; }
      finally { if (timeout) clearTimeout(timeout); }
    }
    async function recover(marker) {
      const navigate = marker.completed !== true;
      busy = true;
      lockControls();
      button.firstChild.textContent = copy.busy;
      status.textContent = copy.busy;
      const found = await reconcile(marker);
      if (found === true) {
        marker.completed = true;
        markPending(marker);
        completed = true;
        uncertain = false;
        error.hidden = true;
        status.textContent = copy.added;
        const completion = root.querySelector('[data-hgs-complete]');
        if (completion) completion.hidden = false;
        button.hidden = true;
        if (navigate) window.location.assign(root.dataset.checkoutUrl || root.dataset.cartUrl);
      } else if (found === false && (marker.rejected === true || marker.completed === true)) {
        remove(pendingKey);
        uncertain = false;
        completed = false;
        button.hidden = false;
        const completion = root.querySelector('[data-hgs-complete]');
        if (completion) completion.hidden = true;
        if (marker.rejected) showError(copy.soldOut);
        else { error.hidden = true; status.textContent = ''; }
      } else {
        uncertain = true;
        showError(copy.uncertain, true);
      }
      busy = false;
      lockControls();
      button.firstChild.textContent = selected().dataset.available === 'true' ?
        (preview ? copy.review : copy.add) : copy.soldOut;
    }
    async function resumePending() {
      if (preview || busy) return;
      const marker = pending();
      if (marker) await recover(marker);
      else if (uncertain) {
        uncertain = false;
        error.hidden = true;
        lockControls();
      }
    }
    async function submit(event) {
      event.preventDefault();
      if (busy || completed || uncertain || !validate()) return;
      error.hidden = true;
      if (preview) {
        review.querySelector('[data-review="kit"]').textContent = selected().dataset.title;
        review.querySelector('[data-review="business"]').textContent = form.elements.business.value;
        review.querySelector('[data-review="brewing"]').textContent = form.elements.brewing.value;
        review.hidden = false;
        review.querySelector('h2').focus();
        return;
      }
      const option = selected();
      if (option.dataset.available !== 'true' || !/^\d+$/.test(option.dataset.variant || '')) return;
      // Capture values before disabling controls. Disabled fields still retain their DOM values,
      // but this snapshot also prevents a concurrent change from altering the submitted order.
      const coffees = [root.dataset.rosebud, root.dataset.ethiopia];
      if (option.value === 'trio') coffees.push(root.dataset.seasonal);
      const properties = {
        'Business name': form.elements.business.value,
        'Brewing plan': form.elements.brewing.value,
        'Tasting kit': option.dataset.title,
        'Kit coffees': coffees.join(' + '),
        'Pack format': root.dataset.pack,
        '_hg_sample_kit': option.value
      };
      if (form.elements.website.value) properties['Business website'] = form.elements.website.value;
      const token = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() :
        String(Date.now()) + '-' + Math.random().toString(36).slice(2) + '-' + Math.random().toString(36).slice(2);
      const marker = {token, variant: option.dataset.variant, saved: Date.now()};
      if (!markPending(marker)) {
        showError(copy.storage || 'Your browser could not save this request. Enable session storage and try again.');
        return;
      }
      properties._hg_sample_request = token;
      busy = true;
      lockControls();
      button.firstChild.textContent = copy.busy;
      status.textContent = copy.busy;
      const controller = typeof AbortController === 'undefined' ? null : new AbortController();
      const timeout = controller ? setTimeout(() => controller.abort(), 12000) : null;
      try {
        const response = await fetch(root.dataset.addUrl, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: option.dataset.variant, quantity: 1, properties}]}),
          ...(controller ? {signal: controller.signal} : {})
        });
        if (response.status >= 400 && response.status < 500) {
          marker.rejected = true;
          markPending(marker);
        }
        // Shopify can add remaining stock even when an add request returns 422.
        // Always read the cart before allowing another submission.
      } catch (_) { /* A timed-out request may still have reached Shopify. */ }
      finally { if (timeout) clearTimeout(timeout); }
      busy = false;
      await recover(marker);
    }
    form.addEventListener('submit', submit);
    form.addEventListener('input', () => { if (!busy) { review.hidden = true; save(); } });
    form.querySelectorAll('[name="kit"]').forEach(input => input.addEventListener('change', update));
    root.querySelector('[data-hgs-edit]').addEventListener('click', () => { review.hidden = true; selected().focus(); });
    window.addEventListener('pageshow', event => { if (event.persisted) resumePending(); });
    update();
    resumePending();
  }
  document.querySelectorAll('[data-hgs]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hgs]').forEach(mount));
})();
